import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const serachPlantLevelConfigSlice = createApi(`SerachPlantLevelConfigSlice`,"GET");

const SerachPlantLevelConfigSlice = createSlice({
  name: 'SerachPlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(serachPlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(serachPlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(serachPlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SerachPlantLevelConfigSlice.reducer;